<template>
  <div class="modal fade" id="largeModall" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true">
    <div class="modal-dialog modal-l">
      <div class="modal-content">
        <div class="modal-body logpop">
          <div class="row pad50">
            <div class="col-md-12">
                <a id="dismis" class=" contbtn" data-dismiss="modal"  style="display:none;">Continue</a>

              <div class="membership marb3" v-if="!registerpg&&!forgot">
                <h6>Get Started</h6>
                <p class="xsfon13">Sign in to your Palaxi Cinemas account to see your booking history and profile setting
                </p>
                <form name="frmTicket" id="frmTicket" @submit.prevent="loginSubmit">



                  <div class="or">


                    <!-- <a href="#" class="facbg"><i class="lni lni-facebook-filled"></i>
                      <small>with Facebook</small>
                    </a> -->
                     <a href="#" class="gool">
                      
                      <GoogleLogin :callback="googleCallback" prompt auto-login  v-if="!customer.loginCode" popup-type="TOKEN">
         <i class="lni lni-google"></i>
                      <small>with Google+</small>
          </GoogleLogin>
                    </a>

                    <span>or</span>
                  </div>



                  <div class="form-group">
                    <input type="text" placeholder="E-mail Address" v-model='logindt.username'>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
  <input :type="passwrdfieldType" placeholder="Password" v-model="logindt.pwd">
  <i :class="passwordIcon" @click="TogglePassword" aria-hidden="true"></i>
</div>
                  <!-- end form-group -->
                  <div class="form-group">
                    <a href="#" class="xsfon12" @click="forgot=true,login=false"><input type="checkbox" checked="true"> Forgot Password?
                    </a> <a href="#" class="xsfon12" style="margin-left: 10px; " @click="registerpg=true,login=false"><input type="checkbox" checked="true">
                      Member Registration
                    </a>
                  </div>
        <div id="msgWrap" class="text-warning">{{logindt.error}}</div>

                  <!-- end form-group -->
                  <div class="form-group">
                    <input type="submit"  :value="logindt.clicked?'Processing..':'LOGIN'" :disabled="logindt.clicked">
                  </div>
                  <!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
<!--Register-->
              <div class="membership marb3" v-if="!login&&!forgot">
                <h6>Signing Up</h6>
                <p class="xsfon13">Sign up to your Palaxi Cinemas account to see your booking history and profile setting
                </p>
                <form name="frmRegister" id="frmRegister" @submit.prevent="regSubmit()">
                  <div class="form-group">
                    <input type="text" placeholder="Name" v-model="register.name">
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="Mobile No" v-model="register.mobile">
                  </div>
                  <div class="form-group">
                    <input type="text" placeholder="E-mail Address" v-model="register.email">
                  </div>
                  <!-- end form-group -->

                  <!-- end form-group -->
                  <div class="form-group">
                    <a href="#" class="xsfon12" @click="forgot=true,registerpg=false"><input type="checkbox" checked="true"> Forgot Password?
                    </a> <a href="#" class="xsfon12" style="margin-left: 10px; " @click="login=true,registerpg=false"><input type="checkbox" checked="true">
                      Already Connected?
                    </a>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
<div id="msgWrap" v-html="register.msg"></div>
                    <input type="submit" :value="register.clicked?'Processing..':'Register'"  :disabled="register.clicked" >
                  </div>
                  <!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
<!--Register-->
              <!-- end membership -->
<!--Forgot-->
              <div class="membership marb3" v-if="!login&&!registerpg">
                <h6>Forgot Password ?</h6>
                <p class="xsfon13">Please provide your registered email ID, we will send the reset password to your inbox.
                </p>
                <form name="frmforgot" id="frmforgot" @submit.prevent="recoverPwd">

                  <div class="form-group">
                    <input type="text" placeholder="E-mail Address" v-model="forgotpwd.email">
                  </div>
                  <!-- end form-group -->

                  <!-- end form-group -->
                  <div class="form-group">
                    <a href="#" class="xsfon12" @click="forgot=false,login=true"><input type="checkbox" checked="true"> Already Connected?
                    </a> <a href="#" class="xsfon12" style="margin-left: 10px; " @click="forgot=false,registerpg=true"><input type="checkbox" checked="true">
                      Member Registration
                    </a>
                  </div>
                  <!-- end form-group -->
                  <div class="form-group">
                    <input type="submit" :value="forgotpwd.clicked?'Processing':'RESET'" :disabled="forgotpwd.clicked" >
                  </div>
<div id="msgWrap" v-html="forgotpwd.msg"></div>

                  <!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
<!--Forgot-->





            </div>
         
            <div> </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import { URL } from '@/conf';
import { decodeCredential } from "vue3-google-login";

export default {
data:()=>({
    register:{name:null,mobile:null,email:null,clicked:null,msg:null},
    forgotpwd:{clicked:null,email:null,msg:null},
    forgotpasswrd:false,
      registerpg:false,
      login:true,
      forgot:false,
    logindt:{code:localStorage.getItem("loginCode"),username:null,pwd:null,error:null},
    customer:{
            loginCode:localStorage.getItem("loginCode"),
            mobile:null,
            email:null,
            name:null,},
    passwordVisible: false,
      passwordIcon: "lni lni-eye",
      passwrdfieldType: "password",
    logSelector: false,
}),
  methods: {
    regSubmit(){
      this.register.msg="<div class='text-danger'>";
      var valid=true;
      if (!this.register.name) {
      valid=false;
      this.register.msg+= 'Name cannot be empty<br>';
      }
      if (!this.register.email) {
        valid=false;
        this.register.msg+= 'Please enter your Email ID<br>';
      } else if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.register.email)) {
        this.register.msg+= 'Email ID is not valid<br>';
        valid=false;
      }
      const filter = /^\d{10}$/;
      if (!filter.test(this.register.mobile)) {
      valid=false;
      this.register.msg+="Enter a valid 10 digit mobile number (without leading zero and +91)<br>";
      }
      this.register.msg+="</div>";
      if(valid)
      {
        this.register.clicked=true;
        axios.post(URL + "register",this.register,{headers: {
                'Content-type': 'application/x-www-form-urlencoded',
              }}).then((response) => {
        this.register.clicked=false;
               if(response.data.status=="done")
               {
                this.register.msg=response.data.msg;
                var that=this;
                setTimeout(function() {
                that.loginpage=true;
                that.register={name:null,email:null,mobile:null,msg:null};
               },2000);
                }if(response.data.status=="error")
               {
this.register.msg=response.data.msg;
               }
            }).catch(()=>{
        this.register.clicked=false;
      this.register.msg="<div class='text-danger'>Something went wrong please try again</div>";
            })}
    },

    TogglePassword(){
      if (this.passwordIcon === "fa fa-eye-slash") {
        this.passwordIcon = "lni lni-eye";
      } else this.passwordIcon = "fa fa-eye-slash";
      if (this.passwrdfieldType == "password") {
        this.passwrdfieldType = "text";
      } else this.passwrdfieldType = "password";
    },
    recoverPwd(){
      this.register.msg="<div class='text-danger'>";
      var valid=true;
      
      if (!this.forgotpwd.email) {
        valid=false;
        this.forgotpwd.msg+= 'Please enter your Email ID<br>';
      } else if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.forgotpwd.email)) {
        this.forgotpwd.msg+= 'Email ID is not valid<br>';
        valid=false;
      }
      this.register.msg+="</div>";
      if(valid)
      {
        this.forgotpwd.clicked=true;
        axios.post(URL + "forgotPwd",this.forgotpwd,{headers: {
                'Content-type': 'application/x-www-form-urlencoded',
              }}).then((response) => {
        this.forgotpwd.clicked=false;
               if(response.data.status=="done")
               {
                this.forgotpwd.msg=response.data.msg;
                var that=this;
                setTimeout(function() {
                that.loginpage=true;
                that.forgotpasswrd=false;
                that.forgotpwd={email:null,msg:null};
               },2000);
                }if(response.data.status=="error")
               {
this.forgotpwd.msg=response.data.msg;
               }
            }).catch(()=>{
        this.forgotpwd.clicked=false;
      this.forgotpwd.msg="<div class='text-danger'>Something went wrong please try again</div>";
            })
      }
     },

     loginSubmit(){
      if(this.logindt.username && this.logindt.pwd)
      {
        this.logindt.clicked=true;
        axios.post(URL + "login",this.logindt,{headers: {
                'Content-type': 'application/x-www-form-urlencoded',
              }}).then((response) => {
        this.logindt.clicked=false;
               if(response.data.status=="done")
               {
                this.logSelector=false;
                this.customer.loginCode=response.data.customer;
                localStorage.setItem("loginCode",response.data.customer.loginCode);
                document.getElementById('dismis').click();
                window.location.reload();
                // this.$router.push("../seatlayout/"+this.showId);

           }if(response.data.status=="error")
               {
this.logindt.error=response.data.msg;
               }else{
            this.logindt.error="Please check your credentials";
           }
            }).catch(()=>{
      
            })}else{
              this.logindt.error="Please check your credentials";
            }
    },
    googleCallback(response) {
      // decodeCredential will retrive the JWT payload from the credential
      var social;
      if(response.credential)
      {
        const userData = decodeCredential(response.credential);
        social={"platform":"google","id":userData.sub,"name":userData.name,"email":userData.email}
      }
    if(response.access_token)
    {
    social={"platform":"google","token":response.access_token}      
    }
    console.log(social);
          this.pushSocialData(social);
    },
    pushSocialData(filds){
      axios.post(URL + "socialLogin",filds,{headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        }}).then((response) => {
         this.logSelector=false;
         if(response.data.status=="done")
         {
          this.customer.loginCode=response.data.social;
          this.customer.name=response.data.name;
          this.customer.email=response.data.email;
          this.customer.mobile=response.data.mobile;
          localStorage.setItem("loginCode",response.data.social);
           location.reload(); 
     }
      }).catch(()=>{

      })
    }
  },
};
</script>